import React, {useEffect, useState} from "react";
import {Button, ButtonGroup, Divider, Input, Select, SelectItem} from "@nextui-org/react";
import {FaEnvelope, FaPlusCircle, FaPhoneAlt, FaUserAlt, FaLock} from 'react-icons/fa';
import {SaveUser} from "../API";


export default function Profile({user}) {
    const roles = {
        1: "adm",
        2: "rep",
        3: "cli",
    }

    const [userdata, setUserdata] = useState([]);
    const [isLoading, setisLoading] = useState(false);
    useEffect(
        () => {
            setUserdata(user);
        }, []
    )


    function OnChange(e) {
        if (e.target.name === "role") {
            const idrole = findKeyByValue(roles, e.target.value);
            setUserdata({...userdata, [e.target.name]: idrole});
        } else
            setUserdata({...userdata, [e.target.name]: e.target.value});
    }

    function NewUser() {
        setUserdata([]);
    }

    const findKeyByValue = (object, value) => {
        return Object.keys(object).find(key => object[key] === value);
    };

    async function Save(e){
        e.preventDefault();
        setisLoading(true);
        const res= await SaveUser(userdata);
        setisLoading(false);
    }
    return (
        <>
            <ButtonGroup className="p-3">
                <Button onClick={NewUser}><FaPlusCircle className="text-success"/> Usuario</Button>
            </ButtonGroup>
            {
                userdata.iduser !== undefined ? (
                    <h1 className="pb-5 text-2xl">Usuario: <b className='text-warning'>{userdata.username}</b></h1>
                ) : null
            }
            <div className=" flex flex-col gap-4">
                <form className="flex w-full flex-wrap gap-4">
                    {
                        userdata.iduser === undefined ? (
                            <>
                                <h2 className="text-xl text-warning">Datos usuario</h2>
                                <Input
                                    type="text"
                                    label="Usuario"
                                    labelPlacement="outside"
                                    value={userdata.username}
                                    onChange={OnChange}
                                    name="username"
                                    required
                                    isRequired
                                    startContent={
                                        <FaUserAlt
                                            className="text-2xl text-default-400 pointer-events-none flex-shrink-0"/>
                                    }
                                />
                                <Input
                                    type="password"
                                    label="Contraseña"
                                    labelPlacement="outside"
                                    value={userdata.password}
                                    onChange={OnChange}
                                    name="password"
                                    required
                                    isRequired
                                    startContent={
                                        <FaLock
                                            className="text-2xl text-default-400 pointer-events-none flex-shrink-0"/>
                                    }
                                />
                                <Input
                                    type="password"
                                    label="Repetir contraseña"
                                    labelPlacement="outside"
                                    value={userdata.replypassword}
                                    name="replypassword"
                                    onChange={OnChange}
                                    required
                                    isRequired
                                    startContent={
                                        <FaLock
                                            className="text-2xl text-default-400 pointer-events-none flex-shrink-0"/>
                                    }
                                />
                                <Divider orientation="horizontal"/>

                            </>

                        ) : null
                    }
                    <h2 className="text-xl text-warning">Datos generales</h2>
                    <Input
                        type="text"
                        label="Nombre"
                        labelPlacement="outside"
                        value={userdata.firstname}
                        onChange={OnChange}
                        name="firstname"
                        required
                        isRequired
                    />
                    <Input
                        type="text"
                        label="Apellido"
                        name="surname"
                        labelPlacement="outside"
                        value={userdata.surname}
                        onChange={OnChange}
                        required
                        isRequired
                    />
                    <Input
                        type="number"
                        label="CI"
                        labelPlacement="outside"
                        value={userdata.dni}
                        name="dni"
                        onChange={OnChange}
                        required
                        isRequired
                    />
                    <Select
                        labelPlacement="outside"
                        label="Rol"
                        isRequired
                        required
                        selectionMode="single"
                        selectedKeys={[roles[userdata.role]]}
                        name="role"
                        onChange={OnChange}
                    >
                        <SelectItem key={"adm"} value={1}>Administrador</SelectItem>
                        <SelectItem key={"rep"} value={2}>Repositor</SelectItem>
                        <SelectItem key={"cli"} value={3}>Cliente</SelectItem>
                    </Select>
                    <Divider orientation="horizontal"/>
                    <h2 className="text-xl text-warning">Contacto</h2>
                    <Input
                        type="email"
                        label="Email"
                        name="email"
                        placeholder="usuario@correo.com"
                        labelPlacement="outside"
                        value={userdata.email}
                        startContent={
                            <FaEnvelope className="text-2xl text-default-400 pointer-events-none flex-shrink-0"/>
                        }
                        onChange={OnChange}
                        required
                        isRequired
                    />
                    <Input
                        type="text"
                        label="Telefono"
                        name="cellphonenumber"
                        placeholder="+595975123456"
                        labelPlacement="outside"
                        value={userdata.cellphonenumber}
                        onChange={OnChange}
                        startContent={
                            <FaPhoneAlt className="text-2xl text-default-400 pointer-events-none flex-shrink-0"/>
                        }
                        required
                        isRequired
                    />

                    <div className="container text-center">
                        <Button color="success" type="submit" onClick={Save} isLoading={isLoading}
                                size="lg">{userdata.iduser === undefined ? "Crear" : "Actualizar"}</Button>

                    </div>

                </form>

            </div>
        </>
    );
}
